import { cn } from 'cn';
import { useTranslation } from 'react-i18next';

import { useQueryAnalyticsKpi } from '~/data/analytics';

import { i18n } from '~/utils';

import { withErrorBoundary } from '@vestigas/ui';

import { getKpiProps, useDateRange } from '../utils';

import { KPI } from './KPI';

/**
 * KpiDeliveryNotesAssigned
 *
 * Displays the number of assigned delivery notes for the selected date range.
 */
export const KpiDeliveryNotesAssigned = withErrorBoundary(
  ({ className, style }: ComponentStyling) => {
    const { t } = useTranslation('analytics');

    const dateRange = useDateRange();

    const { data, isFetching } = useQueryAnalyticsKpi({
      dateRange,
      kpiName: 'assigned_dlns',
    });

    const kpi = getKpiProps({
      iconMetaphor: 'deliveryNoteAssigned',
      kpiColor: 'text-green-700',
      label: t(($) => $.usage.deliveryNotes.assigned),
      previousValue: data?.previousValue,
      tooltip: t(($) => $.usage.deliveryNotes.assignedTooltip),
      value: data?.value,
    });

    return (
      <KPI
        className={cn(
          'rounded-lg border border-green-300 bg-green-100 p-4',
          className,
        )}
        style={style}
        isLoading={isFetching}
        {...kpi}
      />
    );
  },
  i18n.t(($) => $.errorBoundary.fallbackMessage, {
    ns: 'analytics',
    section: i18n.t(($) => $.usage.deliveryNotes.assigned, { ns: 'analytics' }),
  }),
);

KpiDeliveryNotesAssigned.displayName = 'KpiDeliveryNotesAssigned';
